<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="products">
      @for (product of products.controls; track product; let index = $index) {
        @if (index == 0) {
          <ng-container [formGroup]="product">
            <ng-container formGroupName="parameters">

              @if (
                form.get('products').at(0).get('parameters').get('renteConjoint').value === null &&
                derrors
              ) {
                <info [option]="optionWarning">
                  Veuillez indiquer si le client souhaite une rente pour le conjoint
                </info>
              }
              @if (
                form.get('products').at(0).get('parameters').get('renteEducationEnfants').value === null &&
                derrors
              ) {
                <info [option]="optionWarning">
                  Veuillez indiquer si le client souhaite une rente éducation pour les enfants
                </info>
              }
              @if (
                form.get('products').at(0).get('parameters').get('fumeur').value === null &&
                derrors
              ) {
                <info [option]="optionWarning">
                  Veuillez indiquer si le client est fumeur
                </info>
              }
              @if (
                form.get('products').at(0).get('parameters').get('optionDosPsy').value === null &&
                derrors
              ) {
                <info [option]="optionWarning">
                  Veuillez indiquer si le client souhaite être assuré contre les risques psychologiques
                </info>
              }
              @if (
                form.get('products').at(0).get('parameters').get('proprietaireResidencePrincipale').value === null &&
                derrors
              ) {
                <info [option]="optionWarning">
                  Veuillez indiquer si le client est propriétaire de sa résidence principale
                </info>
              }
              @if (
                form.get('products').at(0).get('parameters').get('preservationSalaireArretTravail').value === null &&
                derrors
              ) {
                <info [option]="optionWarning">
                  Veuillez indiquer la préservation du salaire en cas d'arrêt de travail
                </info>
              }
              @if (
                form.get('products').at(0).get('parameters').get('preservationSalaireInvalidite').value === null &&
                derrors
              ) {
                <info [option]="optionWarning">
                  Veuillez indiquer la préservation du salaire en cas d'invalidité
                </info>
              }
              @if (
                form.get('products').at(0).get('parameters').get('tnsChargesProfessionnelles').value === null &&
                derrors
              ) {
                <info [option]="optionWarning">
                  Veuillez indiquer la couverture des charges professionnelles
                </info>
              }
              @if (
                form.get('products').at(0).get('parameters').get('avocatCollaborateur').value === null &&
                derrors
              ) {
                <info [option]="optionWarning">
                  Veuillez indiquer si le client est avocat collaborateur
                </info>
              }
              @if (
                form.get('products').at(0).get('parameters').get('dossiersPersonnels').value === null &&
                derrors
              ) {
                <info [option]="optionWarning">
                  Veuillez indiquer si le client a des dossiers personnels
                </info>
              }
              @if (
                form.get('products').at(0).get('parameters').get('risqueDoubleIndemnisation').value === null &&
                derrors
              ) {
                <info [option]="optionWarning">
                  Veuillez indiquer si un risque de double indemnisation est identifié
                </info>
              }
              @if (
                form.get('products').at(0).get('parameters').get('clientInformeRisqueCumul').value === null &&
                derrors
              ) {
                <info [option]="optionWarning">
                  Veuillez indiquer si le client est informé du risque de cumul
                </info>
              }
              @if (
                form.get('products').at(0).get('parameters').get('justificationSouscription').value?.length === 0 &&
                derrors
              ) {
                <info [option]="optionWarning">
                  Veuillez sélectionner au moins une justification de souscription
                </info>
              }

              <!-- Régime Obligatoire (RO) -->
              <div class="section-card">
                <div class="section-title">Régime Obligatoire (RO)</div>
                <div class="row">
                  <div class="col-md-12">
                    <pr-input-column label="Régime obligatoire" [derrors]="derrors">
                      <pr-select-search
                        formControlName="regimeObligatoire"
                        label="Régime obligatoire"
                        [options]="regimeOptions"
                        optionDisplayKey="label"
                      ></pr-select-search>
                    </pr-input-column>
                  </div>
                </div>
              </div>

              <!-- Revenu -->
              <div class="section-card">
                <div class="section-title">Revenu</div>
                <div class="row">
                  <div class="col-md-12">
                    <pr-input-column label="Revenu couverture net annuel" [derrors]="derrors" [suffix]="'€/an'">
                      <input formControlName="beneficeNetAnnuel" type="text" placeholder="0" />
                    </pr-input-column>
                  </div>
                </div>
              </div>

              <!-- Foyer -->
              <div class="section-card">
                <div class="section-title">Foyer</div>
                <div class="row">
                  <div class="col-md-12">
                    <pr-input-radio
                      formControlName="proprietaireResidencePrincipale"
                      columns="3"
                      [toggle]="true"
                      [isDefault]="false"
                      label="Propriétaire de sa résidence principale"
                    ></pr-input-radio>
                  </div>
                </div>
                <div class="row mt-1">
                  <div class="col-md-6">
                    <pr-input-column label="Acquisition de la résidence principale" [derrors]="derrors">
                      <pr-select-search
                        formControlName="acquisitionResidencePrincipale"
                        label="Acquisition de la résidence principale"
                        [options]="acquisitionResidenceOptions"
                        optionDisplayKey="label"
                      ></pr-select-search>
                    </pr-input-column>
                  </div>
                  <div class="col-md-6">
                    <pr-input-column label="Quotité d'assurance sur l'emprunt" [derrors]="derrors" [suffix]="'%'">
                      <input formControlName="quotiteAssuranceEmprunt" type="text" placeholder="0" />
                    </pr-input-column>
                  </div>
                </div>
                <div class="row mt-1">
                  <div class="col-md-6">
                    <pr-input-radio
                      formControlName="renteConjoint"
                      columns="3"
                      [toggle]="true"
                      [isDefault]="false"
                      label="Rente pour le conjoint"
                    ></pr-input-radio>
                  </div>
                  <div class="col-md-6">
                    <pr-input-radio
                      formControlName="renteEducationEnfants"
                      columns="3"
                      [toggle]="true"
                      [isDefault]="false"
                      label="Rente éducation pour les enfants"
                    ></pr-input-radio>
                  </div>
                </div>
                <div class="row mt-1">
                  <div class="col-md-6">
                    <pr-input-radio
                      formControlName="fumeur"
                      columns="3"
                      [toggle]="true"
                      [isDefault]="false"
                      label="Fumeur"
                    ></pr-input-radio>
                  </div>
                  <div class="col-md-6">
                    <pr-input-radio
                      formControlName="optionDosPsy"
                      columns="3"
                      [toggle]="true"
                      [isDefault]="false"
                      label="Souhaitez-vous être assuré contre les risques psychologiques (burn-out, dépression) ?"
                    ></pr-input-radio>
                  </div>
                </div>
              </div>

              <!-- Préservation du salaire -->
              <div class="section-card">
                <div class="section-title">Préservation du salaire</div>
                <div class="row">
                  <div class="col-md-12">
                    <pr-input-radio
                      formControlName="preservationSalaireArretTravail"
                      columns="3"
                      [toggle]="true"
                      [isDefault]="false"
                      label="Préservation tout ou partie du salaire actuel en cas d'arrêt de travail (hospitalisation, accident, maladie)"
                    ></pr-input-radio>
                  </div>
                </div>
                <div class="row mt-1">
                  <div class="col-md-12">
                    <pr-input-column label="Montant net mensuel à toucher en cas de problème de santé ou d'accident" [derrors]="derrors" [suffix]="'€/mois'">
                      <input formControlName="montantArretTravail" type="text" placeholder="0" />
                    </pr-input-column>
                  </div>
                </div>
                <div class="row mt-1">
                  <div class="col-md-12">
                    <pr-input-radio
                      formControlName="preservationSalaireInvalidite"
                      columns="3"
                      [toggle]="true"
                      [isDefault]="false"
                      label="Préservation tout ou partie du salaire actuel en cas d'invalidité partielle ou totale (maladie grave ou longue durée, accident grave entraînant une immobilisation dans la durée...)"
                    ></pr-input-radio>
                  </div>
                </div>
                <div class="row mt-1">
                  <div class="col-md-12">
                    <pr-input-column label="Montant net mensuel à toucher en cas de problème de santé ou d'accident" [derrors]="derrors" [suffix]="'€/mois'">
                      <input formControlName="montantInvalidite" type="text" placeholder="0" />
                    </pr-input-column>
                  </div>
                </div>
              </div>

              <!-- Travailleur non salarié -->
              <div class="section-card">
                <div class="section-title">Travailleur non salarié</div>
                <div class="row">
                  <div class="col-md-12">
                    <pr-input-radio
                      formControlName="tnsChargesProfessionnelles"
                      columns="3"
                      [toggle]="true"
                      [isDefault]="false"
                      label="Je souhaite, en cas d'arrêt de travail ou d'invalidité, pouvoir couvrir mes charges professionnelles fixes à hauteur d'un certain montant pour protéger mon activité"
                    ></pr-input-radio>
                  </div>
                </div>
                <div class="row mt-1">
                  <div class="col-md-12">
                    <pr-input-column label="Montant des charges professionnelles à couvrir annuellement" [derrors]="derrors" [suffix]="'€/an'">
                      <input formControlName="montantChargesProfessionnelles" type="text" placeholder="0" />
                    </pr-input-column>
                  </div>
                </div>
              </div>

              <!-- Profession spécifique -->
              <div class="section-card">
                <div class="section-title">Profession spécifique</div>
                <div class="row">
                  <div class="col-md-6">
                    <pr-input-radio
                      formControlName="avocatCollaborateur"
                      columns="3"
                      [toggle]="true"
                      [isDefault]="false"
                      label="Avocat collaborateur"
                    ></pr-input-radio>
                  </div>
                  <div class="col-md-6">
                    <pr-input-radio
                      formControlName="dossiersPersonnels"
                      columns="3"
                      [toggle]="true"
                      [isDefault]="false"
                      label="Dossiers personnels"
                    ></pr-input-radio>
                  </div>
                </div>
              </div>

              <!-- Analyse du risque de cumul -->
              <div class="section-card">
                <div class="section-title">Analyse du risque de cumul</div>
                <div class="row">
                  <div class="col-md-6">
                    <pr-input-radio
                      formControlName="risqueDoubleIndemnisation"
                      columns="3"
                      [toggle]="true"
                      [isDefault]="false"
                      label="Risque de double indemnisation identifié"
                    ></pr-input-radio>
                  </div>
                  <div class="col-md-6">
                    <pr-input-radio
                      formControlName="clientInformeRisqueCumul"
                      columns="3"
                      [toggle]="true"
                      [isDefault]="false"
                      label="Client informé du risque de cumul"
                    ></pr-input-radio>
                  </div>
                </div>
                <div class="row mt-1">
                  <div class="col-md-12">
                    <span class="pr-input-label ng-star-inserted">Justification de la souscription <em style="color:#a00d0d">&#160;*</em></span>
                    <div class="checkbox">
                      <ng-template #justificationDefault></ng-template>
                      <pr-checkbox-group
                        formControlName="justificationSouscription"
                        [template]="justificationDefault"
                        [options]="justificationOptions"
                      ></pr-checkbox-group>
                    </div>
                  </div>
                </div>
                <div class="row mt-1">
                  <div class="col-md-12">
                    <pr-input-column label="Commentaire justification" [derrors]="derrors" [isDefault]="false">
                      <textarea class="full-w" type="text" formControlName="justificationCommentaire" rows="2" placeholder="Précisez la justification..."></textarea>
                    </pr-input-column>
                  </div>
                </div>
              </div>

              <!-- Notes -->
              <div class="section-card">
                <div class="section-title">Notes</div>
                <div class="row">
                  <div class="col-md-12">
                    <pr-input-column label="" [derrors]="derrors" [isDefault]="false">
                      <textarea class="full-w" type="text" formControlName="notes" rows="3" placeholder="Commencez à écrire"></textarea>
                    </pr-input-column>
                  </div>
                </div>
              </div>

            </ng-container>
          </ng-container>
        }
      }
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
